
const colors = {
    dark_blue: "#4287f5",
    light_gray: "#f0f0f0",
}

export default colors;